// fill="${color ? color : "currentColor"}"
// width=${width}
// height=${height}
// currentColor ใส่เเทนสี ที่ต้องการเปลี่ยน สีตาม  ConfigProvider theme
import PropTypes from 'prop-types'

import React from 'react'

const Index = ({ width = 16, height = 16, color }) => {
  const svgXml = `<svg
      width=${width}
      height=${height}
      viewBox="0 0 86 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      >
      <path
          d="M48.4127 3.5083L84.3877 65.8166C84.9363 66.7667 85.2251 67.8445 85.2251 68.9416C85.2251 70.0387 84.9363 71.1164 84.3878 72.0666C83.8392 73.0167 83.0503 73.8057 82.1002 74.3542C81.1501 74.9028 80.0723 75.1916 78.9752 75.1916H7.02523C5.92814 75.1916 4.85039 74.9028 3.90029 74.3542C2.95019 73.8057 2.16123 73.0167 1.61269 72.0666C1.06416 71.1164 0.775384 70.0387 0.775391 68.9416C0.775398 67.8445 1.06419 66.7667 1.61273 65.8166L37.5877 3.5083C39.9919 -0.658366 46.0044 -0.658366 48.4127 3.5083ZM43.0002 52.8916C41.8952 52.8916 40.8354 53.3306 40.054 54.112C39.2726 54.8934 38.8336 55.9532 38.8336 57.0583C38.8336 58.1634 39.2726 59.2232 40.054 60.0046C40.8354 60.786 41.8952 61.225 43.0002 61.225C44.1053 61.225 45.1651 60.786 45.9465 60.0046C46.7279 59.2232 47.1669 58.1634 47.1669 57.0583C47.1669 55.9532 46.7279 54.8934 45.9465 54.112C45.1651 53.3306 44.1053 52.8916 43.0002 52.8916ZM43.0002 23.725C41.9797 23.7251 40.9947 24.0998 40.232 24.7779C39.4694 25.4561 38.9821 26.3906 38.8627 27.4041L38.8336 27.8916V44.5583C38.8347 45.6203 39.2414 46.6418 39.9704 47.414C40.6995 48.1862 41.6959 48.6509 42.756 48.7132C43.8162 48.7754 44.8601 48.4305 45.6745 47.7489C46.4889 47.0672 47.0123 46.1004 47.1377 45.0458L47.1669 44.5583V27.8916C47.1669 26.7866 46.7279 25.7268 45.9465 24.9454C45.1651 24.164 44.1053 23.725 43.0002 23.725Z"
          fill="${color ? color : '#FF4D4F'}"
      />
      </svg>
   `

  return (
    <div
      style={{ display: 'flex', alignItems: 'center' }}
      dangerouslySetInnerHTML={{ __html: svgXml }}
    />
  )
}
Index.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
}
export default Index
